import React from "react";
import styled from "styled-components";
import { Button, Checkbox, Form } from "semantic-ui-react";

export const StyledButton = styled(Button)`
  &&& {
    display: flex;
    background-color: #1b1c1d;
    color: #fff;
    transition: background-color 0.3s ease;
  }
`;
export const ContainerLimitante = styled.div`
  margin-top: 1rem;
`;
export const StyledCheckbox = styled(Checkbox)`
  &&& {
    margin-bottom: 1rem;
  }
`;

export const StyledCheckboxLeft = styled(Checkbox)`
  &&& {
    margin-left: 1rem;
  }
`;

export const DivColumDraw = styled.div`
  border: 1px solid #0002;
  display: "flex";
  flex-direction: "column";
`;

export const ParagraphColumDraw = styled.p`
  font-size: 16px;
  margin-top: 5px;
`;

export const StyledLabel = styled.label`
  margin-top: 2em;
  color: rgba(0, 0, 0, 0.87);
`;

export const LabelColumDrawBotton = styled.label`
  margin-bottom: "2em";
`;

export const StyledLabelRed = styled.label`
  color: red !important;
`;
export const StyledCheck = styled.div`
  display: inline-block;
  font-weight: normal;
  margin-left: 1rem;
`;

export const Field = styled(Form.Field)`
  margin: 20px 0 !important;
  width: ${(props) => (props.big && "100%") || (props.small && "20%")};
`;

export const InputFile = styled.input`
  height: 30px;
  padding: 0px !important;
  border: 0 !important;
  display: block;

  margin-top: 10px !important;

  &::-webkit-file-upload-button {
    visibility: hidden;
  }

  &::before {
    content: "Escolha arquivo";
    display: inline-block;
    background: linear-gradient(top, #f9f9f9, #e3e3e3);
    border: 1px solid #999;
    border-radius: 3px;
    padding: 5px 8px;
    outline: none;
    white-space: nowrap;
    -webkit-user-select: none;
    cursor: pointer;
    text-shadow: 1px 1px #fff;
    font-weight: 700;
    font-size: 10pt;
  }

  &:hover::before {
    border-color: black;
  }

  &:active::before {
    background: -webkit-linear-gradient(top, #e3e3e3, #f9f9f9);
  }
`;
